import SingleEmailNoteIcon from '../../../icons/note-email.svg'

// shoudn't return value cause we need `undefined` for `Icon` prop to use default icon in `TableCellNote`
export function getNoteIcon(singleEmailAccount) {
  if (singleEmailAccount) {
    return SingleEmailNoteIcon
  }
}
